import { FC } from "react";
import { ClipLoader } from "react-spinners";

export const Spinner: FC<{ size?: number; className?: string }> = ({
  size = 18,
  className,
}) => {
  return (
    <ClipLoader
      className={className}
      size={size}
      color="#2cd19e"
      loading
      speedMultiplier={0.5}
    />
  );
};
